var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditorCropConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5602 0.26657C25.0705 0.68117 25.148 1.43094 24.7334 1.94121L9.25727 20.9888C9.02989 21.2687 8.68792 21.4303 8.32733 21.4285C7.96673 21.4267 7.62644 21.2615 7.40186 20.9794L0.259025 12.0045C-0.150379 11.49 -0.0652599 10.7411 0.449203 10.3316C0.963605 9.9222 1.71259 10.0073 2.12199 10.5218L8.34292 18.3384L22.8855 0.439808C23.3001 -0.0704702 24.0499 -0.148035 24.5602 0.26657Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditorCropConfirm);
export default __webpack_public_path__ + "static/media/ImageEditorCropConfirm.3759e85b0683c780e4441fe174e65221.svg";
export { ForwardRef as ReactComponent };